import { useCallback } from 'react';
import { deleteNamespace } from '../../../../api/deleteNamespace';
import { getAPIErrorMessage } from '../../../../helpers/helpers';
import {
  NotificationType,
  useNotificationStore,
} from '../../../../store/storeNotifications';
import type { Namespace } from '../../../../types/namespace';
import type { Space } from '../../../../util/Types/Sidebar';

interface UseVectorMemoryDeletionArgs {
  spaces: Space[];
  updateSpace: (spaceId: string, updater: (space: Space) => Space) => void;
  refreshSidebar: () => void;
}

export const useVectorMemoryDeletion = ({
  spaces,
  updateSpace,
  refreshSidebar,
}: UseVectorMemoryDeletionArgs) => {
  const setNotification = useNotificationStore(s => s.setNotification);

  const deleteVectorMemory = useCallback(
    async (ns: Namespace) => {
      const spaceId = spaces.find(s =>
        s.namespaces?.some(n => n.id === ns.id),
      )?.id;
      try {
        if (spaceId) {
          updateSpace(spaceId, space => ({
            ...space,
            namespaces: space.namespaces?.filter(n => n.id !== ns.id) ?? [],
          }));
        } else {
          refreshSidebar();
        }
        await deleteNamespace({
          body: {
            embeddingModelName: ns.embeddingModelName || 'voyage-3-large',
          },
          params: { id: ns.id, nameSpace: ns.name, spaceId },
        });
        setNotification({
          type: NotificationType.Success,
          message: 'Vector memory deleted successfully',
        });
      } catch (error) {
        refreshSidebar();
        setNotification({
          type: NotificationType.Error,
          message: getAPIErrorMessage(error as Error),
        });
      }
    },
    [spaces, updateSpace, refreshSidebar, setNotification],
  );

  return { deleteVectorMemory };
};
